import { Button } from '@alison/ui';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import type { ReactNode } from 'react';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  danger?: boolean;
  isPending: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel = 'Cancel',
  danger = false,
  isPending,
  onCancel,
  onConfirm,
}: ConfirmDialogProps): ReactNode {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      slotProps={{ paper: { sx: { borderRadius: 1.5, maxWidth: 420 } } }}
      data-testid="dialog-confirm"
    >
      <DialogTitle sx={{ fontSize: 16, fontWeight: 700 }}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontSize: 13, color: 'text.secondary' }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button variant="text" onClick={onCancel} data-testid="button-confirm-cancel">
          {cancelLabel}
        </Button>
        <Button
          variant={danger ? 'contained' : 'gradient'}
          color={danger ? 'error' : undefined}
          disableElevation={danger}
          disabled={isPending}
          onClick={onConfirm}
          data-testid="button-confirm-accept"
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
